module.exports = __webpack_public_path__ + "images/Monti_2510-5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/babel/Monti_2510-5.jpg
// module id = 54
// module chunks = 0